import { formatLabel } from './formatLabel.ts';
import { groupsUnderGoals, TOWNSQUARE_GROUP_LABEL } from './townsquare.ts';

/**
 * Customer-facing product display name, or undefined when the link carries no
 * product. Never surfaces the internal `townsquare` codename (collapses to
 * "Goals"); preserves already-capitalized provider names (e.g. GitHub,
 * OneDrive) instead of splitting them into "Git Hub" / "One Drive"; otherwise
 * Title-Cases via formatLabel.
 */
export const formatProduct = (product: string | undefined): string | undefined => {
	if (!product) {
		return undefined;
	}
	if (groupsUnderGoals(product)) {
		return TOWNSQUARE_GROUP_LABEL;
	}
	if (/^[A-Z]/.test(product)) {
		return product;
	}
	return formatLabel(product) ?? product;
};
